import {makeAutoObservable} from "mobx";
import {IRmaResolution} from "../rma-types";
import { RESOLUTION_ID } from "../../../resolutions/constants";

class RmaResolutionStore {
    private _model: IRmaResolution = {} as IRmaResolution;
    
    constructor(model: IRmaResolution) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: IRmaResolution){
        this._model = model;
    }
    
    public get name(): string { return this._model.internal_name; }
    public get resolutionId(): RESOLUTION_ID { return this._model.resolution_id; }
}

export { RmaResolutionStore as default };
